import createTypes from 'redux-create-action-types';

export default createTypes('TUTORIAL_UPDATE');
